const dictionary = {
  fields: [
    [ 'drawer_Home','_________',"ראשי" ],
    [ 'drawer_Busses','_________',"מידע רכבים" ],
    [ 'drawer_Notes','_________',"הודעות" ],
    [ 'drawer_Parts','_________',"מחירון חלפים" ],
    [ 'drawer_Parts2','_________',"שגרות טיפולים לדגם" ],
    [ 'drawer_Books','_________',"ספריה" ],
    [ 'drawer_Driver','_________',"לנהג" ],
    [ 'drawer_Tech','_________',"טכני" ],
    [ 'drawer_ERP','_________',"קטלוגים כלליים" ],
    [ 'drawer_Claims','_________',"תביעות"],
    [ 'drawer_Claims2','_________',"הדרכות ומערכות מידע"],
    [ 'drawer_Service','_________',"היסטוריה ארצית לרכב"],
    [ 'drawer_VehicleTreatmentHistory','_________',"היסטוריה לטיפולים"],
    [ 'drawer_Feedback','_________',"משוב"],

    // labels
    [ 'SEARCH','_________',"חיפוש" ],
    [ 'FREE_SEARCH','_________',"חיפוש חופשי" ],
    [ 'DOWNLOAD','_________',"הורדה" ],
    [ 'basicInfo','_________',"בסיסי" ],
    [ 'Info','_________',"מידע" ],
    [ 'Amounts','_________',"סכומים" ],
    [ 'dates','_________',"תאריכים" ],
    [ 'model','_________',"דגם" ],
    [ 'techDetails','_________',"מידע טכני" ],
    [ 'services','_________',"שירות" ],
    [ 'files','_________',"קבצים" ],
    [ 'N/A','_________',"אין מידע" ],
    [ 'NoData','_________',"לא נמצא" ],
    [ 'Loading','_________',"טוען..." ],
    [ 'selectBookCategory','_________',"בחר קטגוריה" ],
    [ 'NotFound','_________',"לא נמצא" ],
    [ 'PartsSearchOneChar', 'Use at least 2 characters or leave empty', 'הזן לפחות 2 תווים או השאר ריק' ],
    [ 'InStock','_________',"במלאי" ],
    [ 'HasReplacement','_________',"יש תחלופה" ],
    [ 'memberName','_________',"מס מרכז שרות"],
    [ 'cardNumber','_________',"מס כרטיס עבודה"],
    [ 'serialNumber','_________',"מס רכב"],
    [ 'chassisNumber','_________',"מס שלדה"],

    // fields
    [ 'SERNUM', 'Serial Number', "מס' מכשיר" ],
    [ 'WARDATE', 'Warranty Start', "תחילת תקופת אחריות" ],
    [ 'WARDATE1','_________',"תום תקופה ראשונה" ],
    [ 'WARDATE2','_________',"תום תקופה שניה" ],
    [ 'YHV_CARPURPOSEDES','_________',"תאור ייעוד" ],
    [ 'YHV_ENGINEMNFDES','_________',"שם יצרן מנוע" ],
    [ 'YHV_GEARBOXNAME','_________',"תיבת הילוכים" ],
    [ 'YHV_AIRCONDDES','_________',"מזגן" ],
    [ 'YHV_AIRPOLLUTDES','_________',"תאור תקן זיהום אוויר" ],
    [ 'YHV_DGMSHERUTNAME','_________',"דגם שירות" ],
    [ 'YHV_SHILDA','_________',"מס' שילדה" ],
    [ 'YHV_MANOA','_________',"מס מנוע" ],
    [ 'YHV_PURDATE','_________',"תאריך רכישה" ],
    [ 'YHV_WARDATEFINAL','_________',"תום תקופת אחריות" ],
    [ 'RDP_WARRMADUZMNF','_________',"מד אוץ אחריות יצרן" ],
    [ 'RDP_LOANNUM','_________',"מספר הסכם אחזקה" ],
    [ 'RDP_WARRMADUZIMP','_________',"מד אוץ אחריות יבואן" ],
    [ 'RDP_FRONTAXLEDES','_________',"תאור סרן קדמי" ],
    [ 'RDP_BACKAXLEDES','_________',"תאור סרן אחורי" ],
    [ 'RDP_COOLINGFANDES','_________',"תאור מניפת קרור" ],
    [ 'RDP_COSTCTREEDES','_________',"מפעיל/אשכול" ],
    [ 'RDP_SNAME','_________',"מ.ש.א" ],
    [ 'RDP_SNAME2','_________',"שם ניידת שרות" ],
    [ 'BOOKNUM','_________',"מספר ספר" ],
    [ 'TITLE','_________',"כותרת" ],
    [ 'SUBTITLE','_________',"תת כותרת" ],
    [ 'EXTFILEDES','_________',"נושא" ],
    [ 'EXTFILENAME','_________',"קובץ " ],
    [ 'PARTNAME','_________', "מק\"ט" ],
    [ 'PARTDES','_________',"תאור מוצר" ],
    [ 'PRICE','_________',"מחיר לצרכן" ],
    [ 'EXTFILENAME','_________',"תמונה" ],
    [ 'RDP_STOCKFLAG','_________',"זמין במלאי?"],
    [ 'YHV_SUBSTFLAG','_________',"קיימים תחליפים"],
    [ 'YHV_MEMBERNAME','_________',"מס מרכז שרות"],
    [ 'YHV_KARTISNO','_________',"מס כרטיס עבודה"],
    [ 'YHV_MEMBERDES','_________',"מרכז שרות"],
    [ 'YHV_SERNUM','_________',"מס אוטובוס"],
    [ 'YHV_REFCLAIMNUM','_________',"מס תביעה יבואן"],
    [ 'YHV_CLAIMTYPEDES','_________',"סוג תביעה"],
    [ 'YHV_LABTOTALS','_________',"סה\"כ עבודה"],
    [ 'YHV_PARTTOTALS','_________',"סה\"כ חלפים"],
    [ 'YHV_OSLTOTALS','_________',"סה\"כ ע.חוץ"],
    [ 'YHV_TOTAL','_________',"סה\"כ לתביעה"],
    [ 'STATDES','_________',"סטטוס התביעה"],
    [ 'DATEOPEN','_________',"תאריך פתיחה"],
    [ 'DATECLOSE','_________',"תאריך סגירה"],
    [ 'MADUZ','_________',"מד אוץ"],
    [ 'TYPE','_________',"סוג רשומה"],
    [ 'PARTNAME2','_________',"מק\"ט/קוד שעתון"],
    [ 'PARTDES2','_________',"תאור מק\"ט/שעתון"],
    [ 'RQUANT','_________',"כמות"],
    [ 'RQUANTORTIME','_________',"כמות/זמן"],
    [ 'YHV_TEXT','_________',"הודעה"],
    [ 'YHV_FDATE','_________',"תאריך"],
  ],
  labels: [
  ]
}

const translations = { fields: { en: { field: {} }, he: { field: {} } } }

for (const rawField of dictionary.fields) {
  translations.fields.en.field[rawField[0]] = rawField[1]
  translations.fields.he.field[rawField[0]] = rawField[2]
}

export default translations.fields
